import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchUser } from 'redux/settings/actions';
import ProFeaturePlaceholder from 'components/common/ProFeaturePlaceholder';
import CommonPopup from 'components/common/CommonPopup';
import './LinksAlignmentSelector.css';
import left from "./images/left.svg";
import center from "./images/center.svg";
import right from "./images/right.svg";

const LinksAlignmentSelector = (props) => {
  const { me, patchUser } = props;
  const { t } = useTranslation();

  const handleChangeLinkAlign = (align) => {
    return () => {
      const form = new FormData();
      form.append('links_align', align);
      patchUser(form);
    };
  };
  
  const alignTypes = [
    {
      alignName: 'left',
      icon: left,
      popupContent: t("Align your text with the left margin. Left alignment makes the profile easier to read."),
    },
    {
      alignName: 'center',
      icon: center,
      pro: true,
      popupContent: t("Center your text. Center alignment gives a more formal appearance."),
    },
    {
      alignName: 'right',
      icon: right,
      pro: true,
      popupContent: t("Align your text with the right margin."),
    },
  ];

  return (
    <div className="links-align-selector__component">
      {alignTypes &&
        alignTypes.map((item) => (
          <ProFeaturePlaceholder
            noKeyIcon
            key={item.alignName}
            placeholderContent={
              <div>
                {t("You can change link font alignment on the PRO plan.")}
              </div>
            }
            proLabel={item.pro}
            locked={
              me &&
              me.subscription &&
              me.subscription.billing_plan.title === 'Starter' &&
              item.pro
            }
          >
            <CommonPopup
              trigger={
                <div
                  className={`link-align-item ${item.alignName === (me && me.links_align) ? 'active' : ''}`}
                  onClick={handleChangeLinkAlign(item.alignName)}
                  role="button"
                >
                  <img src={item.icon} />
                  <p>{t(`${item.alignName}`)}</p>
                </div>
              }
            >
              {item.popupContent}
            </CommonPopup>
          </ProFeaturePlaceholder>
        ))}
    </div>
  );
};

LinksAlignmentSelector.propTypes = {
  me: PropTypes.object,
  patchUser: PropTypes.func.isRequired,
};

LinksAlignmentSelector.defaultProps = {
  me: null,
};

const mapStateToProps = (state) => ({
  me: state.usersReducer.me,
});

const mapDispatchToProps = {
  patchUser,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LinksAlignmentSelector);
